import request from '../../axios';

export interface IPostCreditOrderTransactionPayload {
  order: string;
}

const postCreateCreditOrderTransaction = async (
  payload: IPostCreditOrderTransactionPayload,
) => {
  const data = await request.post(
    `api/v2/payment/create-order-transaction-with-credit`,
    payload,
  );

  return data;
};

export default postCreateCreditOrderTransaction;
